import router from "@/router";

const tours = {
  coachTeam: {
    steps: [
      {
        target: '[data-v-step="0"]',
        title: "Welcome",
        content: "Welcome to the new team dashboard!",
        params: {
          enableScrolling: false
        }
      },
      {
        target: '[data-v-step="1"]',
        title: "Roster",
        content: "Here is the new team roster.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `#admin-row-0`,
        title: "OrgAdmins",
        content: "The head coach and admins are listed at the top.",
        params: {
          position: "top",
          enableScrolling: false
        }
      },
      {
        target: `#player-row-0`,
        title: "Players",
        content: "Next are the players.",
        params: {
          position: "top",
          enableScrolling: false
        }
      },
      {
        target: `.expand-icon`,
        title: "Players Expand",
        content:
          "Click this icon to see a list of the player's fans and followers.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.player-name-step`,
        title: "Players Name",
        content: "Click the player's name to view and edit their profile.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `#close-iframe-modal`,
        title: "Close Player Profile",
        content: "Click here to close the Player Profile.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.player-select-step`,
        title: "Players Select",
        content: "Click the checkbox on a member of your team to select them.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.every-select-step`,
        title: "Players Select",
        content:
          "Click the checkbox at the top to select every member of your team.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.chat-with-selected`,
        title: "Chat",
        content:
          "Click here to start a chat with the team members you have selected.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.close-chat-modal`,
        title: "Close Chat",
        content: "Click here to close.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.email-selected`,
        title: "Email",
        content: "Click here to email the team members you have selected",
        params: {
          enableScrolling: false
        }
      },
      {
        target: ".close",
        title: "Close Email",
        content: "Email works exactly as it did before. Click here to close.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.remove-selected`,
        title: "Remove",
        content:
          "Warning! Do Not Click here unless you want to remove the team members you have selected.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.every-select-step`,
        title: "Players Deselect",
        content:
          "You can click here again to deselect all of the team members you have selected.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.add-import-step`,
        title: "Add Import Players",
        content: "Click here access options to add or import players.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.settings-step`,
        title: "Settings",
        content: "Click here to edit your team's settings.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.close`,
        title: "Close Settings",
        content: "Click here to close.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.view-players-step`,
        title: "View All Players",
        content:
          "Click here to see a detailed overview of all the players on your team, including archived players.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.close-players`,
        title: "Close View All Players",
        content: "Click here to close.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.manage-admins-step`,
        title: "Manage Admins",
        content: "Click here to manage your team's admins.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.close`,
        title: "Close Admins",
        content: "Click here to close.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.chat-with-admins-step`,
        title: "Chat with admins",
        content: "Click here to start a chat with your team's admins.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: `.close-chat-modal`,
        title: "Close Chat with admins",
        content: "Click here to close.",
        params: {
          enableScrolling: false
        }
      }
    ],
    callbacks: {
      onNextStep: (currentStep: number) => {
        if (currentStep === 3) {
          //@ts-ignore
          document
            .getElementsByClassName("expand-icon")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-3").click();
            });
        } else if (currentStep === 4) {
          //@ts-ignore
          document
            .getElementsByClassName("player-name-step")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-4").click();
            });
        } else if (currentStep === 5) {
          //@ts-ignore
          //@ts-ignore
          document
            .getElementById("close-iframe-modal")
            .addEventListener("click", () => {
              document.addEventListener("loadingOff", () => {
                //@ts-ignore
                setTimeout(() => {
                  //@ts-ignore
                  document.getElementById("tour-next-step-5").click();
                }, 1000);
              });
            });
        } else if (currentStep === 6) {
          //@ts-ignore
          document
            .getElementsByClassName("player-select-step")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-6").click();
            });
        } else if (currentStep === 7) {
          //@ts-ignore
          document
            .getElementsByClassName("every-select-step")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-7").click();
            });
        } else if (currentStep === 8) {
          //@ts-ignore
          document
            .getElementsByClassName("chat-with-selected")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              setTimeout(() => {
                //@ts-ignore
                document.getElementById("tour-next-step-8").click();
              }, 1000);
            });
        } else if (currentStep === 9) {
          document
            .getElementsByClassName("close-chat-modal")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-9").click();
            });
        } else if (currentStep === 10) {
          document
            .getElementsByClassName("email-selected")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              setTimeout(() => {
                document
                  .getElementsByClassName("close")[0]
                  .classList.remove("close");
                //@ts-ignore
                document.getElementById("tour-next-step-10").click();
              }, 1000);
            });
        } else if (currentStep === 11) {
          //@ts-ignore
          document
            .getElementsByClassName("close")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-11").click();
            });
        } else if (currentStep === 13) {
          //@ts-ignore
          document
            .getElementsByClassName("every-select-step")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-13").click();
            });
        } else if (currentStep === 14) {
          //@ts-ignore
          document
            .getElementsByClassName("add-import-step")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-14").click();
            });
        } else if (currentStep === 15) {
          //@ts-ignore
          document
            .getElementsByClassName("settings-step")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              setTimeout(
                //@ts-ignore
                () => document.getElementById("tour-next-step-15").click(),
                1000
              );
            });
        } else if (currentStep === 16) {
          document
            .getElementsByClassName("close")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-16").click();
            });
        } else if (currentStep === 17) {
          //@ts-ignore
          document
            .getElementsByClassName("view-players-step")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-17").click();
            });
        } else if (currentStep === 18) {
          //@ts-ignore
          document
            .getElementsByClassName("close-players")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-18").click();
            });
        } else if (currentStep === 19) {
          //@ts-ignore
          document
            .getElementsByClassName("manage-admins-step")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              setTimeout(
                //@ts-ignore
                () => document.getElementById("tour-next-step-19").click(),
                1000
              );
            });
        } else if (currentStep === 20) {
          //@ts-ignore
          document
            .getElementsByClassName("close")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-20").click();
            });
        } else if (currentStep === 21) {
          //@ts-ignore
          document
            .getElementsByClassName("chat-with-admins-step")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-21").click();
            });
        } else if (currentStep === 22) {
          //@ts-ignore
          document
            .getElementsByClassName("close-chat-modal")[0]
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-finish-22").click();
            });
        }
      }
    }
  },
  coachNav: {
    steps: [
      {
        target: ".nav-tour-step-1",
        title: "Coach Nav",
        content: "Teambot has make some updates to navigation.",
        params: {
          enableScrolling: false
        }
      },
      {
        target: ".nav-tour-step-2",
        title: "Players and Teams Selector",
        content: "Click here to access your teams.",
        params: {
          position: "bottom",
          enableScrolling: false
        }
      },
      {
        target: ".nav-tour-step-2",
        title: "Select a team",
        content: "Click on a team or organization to select it.",
        params: {
          position: "bottom",
          enableScrolling: false
        }
      },
      // {
      //   target: ".nav-tour-step-2",
      //   title: "Current active selection",
      //   content: "The team you are currently working with will show here.",
      //   params: {
      //     position: "bottom",
      //     enableScrolling: false
      //   }
      // },
      {
        target: "#teams",
        title: "Teams Page",
        content: `${
          router.currentRoute.name === "CoachTeams" ? "You can click" : "Click"
        } here to see the team dashboard.`,
        params: {
          position: "bottom",
          enableScrolling: false
        }
      },
      {
        target: "#calendar",
        title: "Calendar Page",
        content: `${
          router.currentRoute.name === "TeamCalendar"
            ? "You can click"
            : "Click"
        } here to see the team calendar.`,
        params: {
          position: "bottom",
          enableScrolling: false
        }
      },
      {
        target: "#email",
        title: "Email Page",
        content: `${
          router.currentRoute.name === "TeamEmail" ? "You can click" : "Click"
        } here to see the team email screen.`,
        params: {
          position: "bottom",
          enableScrolling: false
        }
      },
      {
        target: "#chat",
        title: "Chat Page",
        content: `${
          router.currentRoute.name === "Chat" ? "You can click" : "Click"
        } here to see the chat screen.`,
        params: {
          position: "bottom",
          enableScrolling: false
        }
      },
      {
        target: "#payments",
        title: "Payments Page",
        content: `${
          router.currentRoute.name === "Payments" ? "You can click" : "Click"
        } here to see the payments screen.`,
        params: {
          position: "bottom",
          enableScrolling: false
        }
      },
      {
        target: "#user-profile",
        title: "User Profile",
        content: "Click here to see your user specific options and to log out.",
        params: {
          position: "bottom",
          enableScrolling: false
        }
      }
    ],
    callbacks: {
      onNextStep: (currentStep: number) => {
        if (currentStep === 0) {
          //@ts-ignore
          document
            .getElementById("expand-player-teams-selector")
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-0").click();
            });
        } else if (currentStep === 1) {
          //@ts-ignore
          const elements = Array.from(
            document.getElementsByClassName("select-team-button")
          );
          elements.slice(1).forEach(el => {
            el.addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-next-step-1").click();
            });
          });
        } else if (
          currentStep === 3 &&
          router.currentRoute.name !== "CoachTeams"
        ) {
          //@ts-ignore
          document.getElementById("teams").addEventListener("click", () => {
            //@ts-ignore
            document.getElementById("tour-next-step-3").click();
          });
        } else if (
          currentStep === 4 &&
          router.currentRoute.name !== "TeamCalendar"
        ) {
          //@ts-ignore
          document.getElementById("calendar").addEventListener("click", () => {
            //@ts-ignore
            document.getElementById("tour-next-step-4").click();
          });
        } else if (
          currentStep === 5 &&
          router.currentRoute.name !== "TeamEmail"
        ) {
          //@ts-ignore
          document.getElementById("email").addEventListener("click", () => {
            //@ts-ignore
            document.getElementById("tour-next-step-5").click();
          });
        } else if (currentStep === 6 && router.currentRoute.name !== "Chat") {
          //@ts-ignore
          document.getElementById("chat").addEventListener("click", () => {
            //@ts-ignore
            document.getElementById("tour-next-step-6").click();
          });
        } else if (
          currentStep === 7 &&
          router.currentRoute.name !== "Paymen@ts"
        ) {
          //@ts-ignore
          document.getElementById("paymen@ts").addEventListener("click", () => {
            //@ts-ignore
            document.getElementById("tour-next-step-7").click();
          });
        } else if (currentStep === 8) {
          //@ts-ignore
          document
            .getElementById("user-profile")
            .addEventListener("click", () => {
              //@ts-ignore
              document.getElementById("tour-finish-8").click();
            });
        }
      }
    }
  }
};

export default tours;
